import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectCPMFTrackingForecastVariable,
  setVariable as setVariableRedux,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import useVariableOptions from './useVariableOptions';

export default function useVariables() {
  const { variables } = useVariableOptions();
  const selectedVariable: string = useSelector(selectCPMFTrackingForecastVariable);
  const setSelectedVariable = (newVariable: string) => (
    store.dispatch(setVariableRedux(newVariable))
  );

  return { variables, selectedVariable, setSelectedVariable };
}
